<template>
    <div class="bnt-search">
        <button @click="goToSchedule" :class="{langKh: addFontKhmer}">{{$t('message.search')}}</button>
    </div>

    <div v-if="show">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.plSelectDeparture')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedDeparture" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>

      <!-- alert dialog -->
    <div v-if="alertDest">
      <div class="van-overlay" style="z-index: 2001;"></div>
      <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
          <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
          <div class="van-dialog__content">
              <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.plSelectDestination')}}</div>
          </div>
          <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
              <button type="button" @click="closedDestination" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                  <div class="van-button__content">
                      <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                  </div>
              </button>
          </div>
      </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            alertDest: false,
            addFontKhmer: false,
        }
    },
    methods: {
        closedDeparture() {
            this.show = false;
        },
        goToSchedule() {
            localStorage.setItem("clearData", '1');
            if(localStorage.getItem('destinationFrom') == '' || localStorage.getItem('destinationFrom') != null && localStorage.getItem('destinationTo') == '' || localStorage.getItem('destinationTo') != null && (localStorage.getItem('dateFrom') == '' || localStorage.getItem('dateFrom') != null)){
                if((localStorage.getItem('destinationFrom') != '') && (localStorage.getItem('destinationTo') != '') && (localStorage.getItem('dateFrom') != '') &&  (localStorage.getItem('dateTo') == '' || localStorage.getItem('dateTo') == null)){
                    localStorage.getItem('destinationFrom');
                    localStorage.getItem('destinationTo');
                    localStorage.getItem('dateFrom');
                    this.$router.push("/schedule-list");
                }else{
                    localStorage.getItem('destinationFrom');
                    localStorage.getItem('destinationTo');
                    localStorage.getItem('dateFrom');
                    localStorage.getItem('dateTo');
                    this.$router.push("/schedule-list");
                }
            }else{
                if(localStorage.getItem('destinationFrom') == null) {
                    this.show = true;
                }else{
                    this.alertDest = true;
                }
            }
        },
        closedDestination() {
            this.alertDest = false;
        },
    },
    created() {
        if(localStorage.getItem("lang") == "en") {
            this.addFontKhmer = false;
        }else {
            this.addFontKhmer = true;
        }
    },
}
</script>

<style>
    .bnt-search button {
        margin-top: 10px;
        width: 100%;
        border-radius: 8px;
        padding: 10px;
        background: #de5d0a;
        border: none;
        color: #FFF;
        font-weight: 500;
    }
</style>